//****VARIABLES****
//CUSTOM//*********************************

//Cache
let cache = {
  sessionID: "",
  productitle: "Historic OS Map",
  productid: 40290702524468,
  details: {
    dims: {
      width: 0,
      height: 0
    },
    frame: {
      moulding: {
        id: 'kingston',
        option1: '7.8mm(0.31in)',
        option2: 'Matt Black'
      },
      mounting: {
        type: 'none',
        depth: {
          in: 0,
          mm: 0
        }
      },
      windowmount: {
        id: 'white/white',
        size: {
          in: 0,
          mm: 0
        }
      }//{ colour: string, type: string, sizing: {type: classic/oversize/narrow, size: {in: num, mm: num}} }
    },
    fullimg: '',
    layout: 'borderless',
    location: [0,52],
    locationfull: {
      town: null,
      county: 'London',
      country: 'United Kingdom'
    },
    mapstyle: 'uk-osgb10k1888',
    printonly: false,
    paper: {
      printmethod: "Giclée",
      type: "Cotton Rag 310gsm",
      size: {
        printarea: {
          in: {
            width: 0,
            height: 0
          },
          mm: {
            width: 0,
            height: 0
          }
        },
        border: {
          in: 0,
          mm: 0
        },
      }
    },
    tempimg: '',
    tiles: [],
    type: {
      media: 'map',//digital, object, frameonly
      additionalmedia: 'paper',
      additionalmediatype: null,
      service: 'printandframe',
      placeholder: null
    },
    units: "in",
  },
};

//Declare options for right menu
let designobj = {
  options: [
    {
      name: "Map Size",
      icon: svgsize,
      description:
        "Change the size of the map area below, to adjust the frame/window mount size go to the Framing tab instead.",
      variants: [
        {
          name: "Preset Sizes",
          id: "size",
          type: "preset",
          variations: [
            //Square
            {name: '12in x 12in', in: {width:12,height:12}, mm: {width: 304.8, height: 304.8}},
            {name: '16in x 16in', in: {width:16,height:16}, mm: {width: 406.4, height: 406.4}},
            {name: '20in x 20in', in: {width:20,height:20}, mm: {width: 508, height: 508}},
            {name: '24in x 24in', in: {width:24,height:24}, mm: {width: 609.6, height: 609.6}},
            //{name: '32in x 32in', in: {width:32,height:32}, mm: {width: 812.8, height: 812.8}},
            //{name: '36in x 36in', in: {width:36,height:36}, mm: {width: 914.4, height: 914.4}},
            //{name: '40in x 40in', in: {width:40,height:40}, mm: {width: 1016, height: 1016}},
            //Portrait
            {name: '8in x 10in', in: {width:8,height:10}, mm: {width: 203.2, height: 254}},
            {name: 'A4', in: {width:8.27,height:11.69}, mm: {width: 210, height: 297}},
            {name: '12in x 16in', in: {width:12,height:16}, mm: {width: 304.8, height: 406.4}},
            {name: 'A3', in: {width:11.69,height:16.54}, mm: {width: 297, height: 420}},
            {name: '16in x 20in', in: {width:16,height:20}, mm: {width: 406.4, height: 508}},
            {name: 'A2', in: {width:16.54,height:23.39}, mm: {width: 420, height: 594}},
            {name: '18in x 24in', in: {width:18,height:24}, mm: {width: 457.2, height: 609.6}},
            {name: 'A1', in: {width:23.39,height:33.11}, mm: {width: 594, height: 841}},
            {name: '24in x 36in', in: {width:24,height:36}, mm: {width: 609.6, height: 914.4}},
            //Landscape
            {name: '10in x 8in', in: {width:10,height:8}, mm: {width: 254, height: 203.2}},
            {name: 'A4', in: {width:11.69,height:8.27}, mm: {width: 297, height: 210}},
            {name: '16in x 12in', in: {width:16,height:12}, mm: {width: 406.4, height: 304.8}},
            {name: 'A3', in: {width:16.54,height:11.69}, mm: {width: 420, height: 297}},
            {name: '20in x 16in', in: {width:20,height:16}, mm: {width: 508, height: 406.4}},
            {name: 'A2', in: {width:23.39,height:16.54}, mm: {width: 594, height: 420}},
            {name: '24in x 18in', in: {width:24,height:18}, mm: {width: 609.6, height: 457.2}},
            {name: 'A1', in: {width:33.11,height:23.39}, mm: {width: 841, height: 594}},
            {name: '36in x 24in', in: {width:36,height:24}, mm: {width: 914.4, height: 609.6}},
          ]
        },
      ],
    },
    {
      name: "Framing",
      icon: svgframe,
      description: "Choose from our selection of frame finishes.",
      variants: [
        {
          name: 'Frame Options',
          id: 'mapstyle',
          type: 'frameselect',
          variations: [
            {
              name: 'Standard',
              id: 'mapstyle',
              options: [
                { name: 'Black', url: 'mapbox://styles/tman16/ck36i7f0s5ra71cm7biergcnw', image: "https://ucarecdn.com/e24df950-7205-43ab-b492-56aa2d3da2d7/Black.jpg" },
                { name: 'Classic W/B', url: "mapbox://styles/tman16/cjz88vqz12k6t1cr6smf1otoy", image: "https://ucarecdn.com/0eb5a9b3-5a28-4e3e-8e7b-89a5d40104e8/White.jpg" },
                { name: 'Classic Red', url: "mapbox://styles/tman16/ck37otgw76tyx1cm7hn8jsni4", image: "https://ucarecdn.com/f22064aa-21e9-4842-b8c9-b5aec1d83003/Red.jpg" },
                { name: 'Classic Blue', url: "mapbox://styles/tman16/ck3w3mgeb3o151cltw4f702w0", image: "https://ucarecdn.com/ac812cba-96f0-44f4-8b50-385fc19023b7/Blue.jpg" },
                { name: 'Classic Green', url: "mapbox://styles/tman16/ck4o2jx9h0jsv1cruiii969fi", image: "https://ucarecdn.com/10095709-cc80-4334-b193-1b6aa8d6407b/Green.jpg" },
                { name: 'Classic Grey', url: "mapbox://styles/tman16/ck4o3vfwa6rmh1cur5jq4yhub", image: "https://ucarecdn.com/d088f6b2-1f0a-43bb-93c1-2d730b4df215/Grey.jpg" },
                { name: 'Classic Orange', url: "mapbox://styles/tman16/ck4o3zbyo4vfk1cms67942ptk", image: "https://ucarecdn.com/4d75a524-7d13-46c3-8d93-2dc7578ed82b/Orange.jpg" },
                { name: 'Nautical', url: "mapbox://styles/tman16/ck4ou2xv709wn1co6zi232ku4", image: "https://ucarecdn.com/9d248a39-91c7-4a43-b0f5-3a6058c0fc39/Nautical.jpg" },
                { name: 'Urban', url: "mapbox://styles/tman16/ck5yk0u4j01zo1io0pche8ioa", image: "https://ucarecdn.com/562ad0ba-705b-4939-bfe7-c6083a964f93/Urban.jpg" },
                { name: 'Streets', url: "mapbox://styles/tman16/ck3y8f50p1sos1cpnheob2xkw", image: "https://ucarecdn.com/1f08f7c7-37a8-4324-ba9b-aaf8cc2ead49/Streets.jpg" },
                { name: 'Satellite', url: "mapbox://styles/tman16/ck0i0d0fa0a7h1dmdgop0zgr1", image: "https://ucarecdn.com/4bf1d56c-a9a4-4730-b805-cc2575d738fa/Satellite.jpg" },
                { name: 'Pop', url: "mapbox://styles/tman16/ck5n7ihw15fbk1io9ay9zghb5", image: "https://ucarecdn.com/459a5852-5b1c-4f53-89bc-8a98bf3c203a/Pop.jpg" },
                { name: 'Maritime', url: 'mapbox://styles/tman16/ck5spo97o3e7u1in3r5f0om68', image: "https://ucarecdn.com/b3156fa9-84a0-40a1-ba87-08bcf14b8db7/Maritime.jpg" },
                { name: 'Mondrian', url: "mapbox://styles/tman16/ck5uaabwt01401ilorq94bgjy", image: "https://ucarecdn.com/7a9cf423-5365-4c71-83d1-697d02df3426/Mondrian.jpg" },
                { name: 'Outdoors', url: "mapbox://styles/tman16/ck7g4djj1025w1io4djfvus0o", image: "https://ucarecdn.com/a96fb794-1d61-4593-bc3a-da2a73ae56e6/Outdoors.jpg" },
                { name: 'Pastel', url: "mapbox://styles/tman16/ckmzpsx1b0djz17p0axe30hn7", image: "https://cdn.shopify.com/s/files/1/0272/8512/7220/files/Pastel.png?v=1617393196" },
                { name: 'Tricolore', url: "mapbox://styles/tman16/ckbcuao6e1kdu1ildxzeg3wdw", image: "https://cdn.shopify.com/s/files/1/0272/8512/7220/files/Tricolore.jpg?v=1621200524" },
              ]
            },
          ]
        },
      ],
    },
    {
      name: "Location",
      icon: svglocationmarker,
      description:
        "Adjust the map area by searching for the location below, Great Britain countries only (England, Wales and Scotland).",
      variants: [
        {
          name: 'Location',
          id: 'location',
          type: 'location'
        },
        {
          name: 'Map Style',
          id: 'mapstyle',
          type: 'colourchips',
          maparr: true
        },
      ],
    }
  ],
};

//Update frame overlay
function updateframeoverlay() {
  if (cache.frame) {
    let selectedFrame = cache.frame.id;

    let selectedratio = cache.dims.width / cache.dims.height;
    console.log("selectedratio: " + selectedratio);

    let findClosest = framejson.reduce(function (prev, curr) {
      let prevratio = (function () {
        let ratio;
        for (let obj of framejson) {
          if (obj.size == prev.size) {
            if (obj.size.indexOf("a") > -1) {
              if (
                obj.size == "a4p" ||
                obj.size == "a3p" ||
                obj.size == "a2p" ||
                obj.size == "a1p"
              ) {
                ratio = 8.27 / 11.69;
              } else if (
                obj.size == "a4l" ||
                obj.size == "a3l" ||
                obj.size == "a2l" ||
                obj.size == "a1l"
              ) {
                ratio = 11.69 / 8.27;
              }
            } else {
              ratio =
                Number(obj.size.split("x")[0]) / Number(obj.size.split("x")[1]);
            }
          }
        }
        return ratio;
      })();

      let currratio = (function () {
        let ratio;
        for (let obj of framejson) {
          if (obj.size == curr.size) {
            if (obj.size.indexOf("a") > -1) {
              if (
                obj.size == "a4p" ||
                obj.size == "a3p" ||
                obj.size == "a2p" ||
                obj.size == "a1p"
              ) {
                ratio = 8.27 / 11.69;
              } else if (
                obj.size == "a4l" ||
                obj.size == "a3l" ||
                obj.size == "a2l" ||
                obj.size == "a1l"
              ) {
                ratio = 11.69 / 8.27;
              }
            } else {
              ratio =
                Number(obj.size.split("x")[0]) / Number(obj.size.split("x")[1]);
            }
          }
        }
        return ratio;
      })();

      return Math.abs(currratio - selectedratio) <
        Math.abs(prevratio - selectedratio)
        ? curr
        : prev;
    });

    let selectedSize = findClosest.size;

    var pageRatio = selectedSize.split("x")[0] / selectedSize.split("x")[1];

    for (var j = 0; j < framejson.length; j++) {
      if (
        selectedSize == framejson[j].size &&
        selectedFrame == framejson[j].frameColour
      ) {
        var imageurl = framejson[j].overlay;
        if (imageurl === "") {
          fabric.Image.fromURL(
            imageurl,
            function (image) {
              canvas.setOverlayImage(null);
              canvas.renderAll();
            },
            { crossOrigin: "anonymous" }
          );

          canvas.setOverlayImage(
            "https://cdn.shopify.com/s/files/1/0272/8512/7220/files/print-frame-co-logo-textonly.png?v=1634587330",
            function () {
              //https://cdn.shopify.com/s/files/1/0272/8512/7220/files/print-frame-co-logo-black_79864e1f-c0d6-4d8e-86a4-8c92c4af668f_300x300.png?v=1597492312
              canvas.overlayImage &&
                canvas.overlayImage.scaleToWidth(canvas.getWidth() / 2);
              canvas.renderAll();
            },
            {
              top: canvas.getHeight() / canvas.getZoom() / 2,
              left: canvas.getWidth() / canvas.getZoom() / 2,
              angle: -45,
              originX: "center",
              originY: "center",
              opacity: 0.05,
              crossOrigin: "Anonymous",
            }
          );
        } else {
          fabric.Image.fromURL(
            imageurl,
            function (image) {
              image.scaleToWidth(canvas.getWidth() / canvas.getZoom());
              image.scaleToHeight(canvas.getHeight() / canvas.getZoom());
              image.set({
                id: "image_frame",
                scaleX: canvas.getWidth() / image.width,
              });
              //canvas.add(image);
              //canvas.setBackgroundImage(image);
              canvas.setOverlayImage(image, canvas.renderAll.bind(canvas));
              canvas.renderAll();
            },
            { crossOrigin: "anonymous" }
          );
        }
      }
    }
  }
}
